import { QueryConfig } from 'react-query'
import { useBackendQuery } from '../useBackendQuery'

export interface UseProductQueryProps {
  /** The slug of the store to fetch products for. */
  store?: string
  /** The slug of the product to fetch. */
  product?: string
  region?: string
}

export function useProductQuery<Product>(
  options: UseProductQueryProps = {},
  config?: QueryConfig<Product>,
) {
  const { store, product, region } = options

  const params = { store, region }

  const query = useBackendQuery<Product>([`products/${product}`, { params }], config)

  return query
}

export default useProductQuery
